export const git =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073315/git_2_zocdjk.png";
export const github =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073315/github_2_d7hlsq.png";
export const express =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073315/express_ejaped.png";
export const nodejs =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073316/nodejs_rfseas.png";
export const java =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073316/java_fbtagc.png";
export const javascript =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073317/javascript_2_osg7tj.png";
export const tailwind =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073315/tailwind_2_tj7d5t.png";
export const react =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073317/react_lnd7xd.png";
export const python =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073317/python_2_erpwgw.png";
export const dataStructure =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745074029/dataStructure-removebg-preview_nqspll.png";
export const php =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073317/php_2_mylrof.png";
export const mongoDb =
  "https://res.cloudinary.com/dksf1htal/image/upload/v1745073316/mongodb_2_kq87a7.png";
